import React, { useEffect, useState } from "react";
import pikug from "../../assets/images/claim/pikug.svg";
import vepikug from "../../assets/images/claim/vepikug.svg";
import lockedpikug from "../../assets/images/claim/lockedpikug.svg";
import useTranslation from "../../Languages/Translation";
import { useWeb3ModalProvider } from "@web3modal/ethers/react";
import { ethers } from "ethers";
import {
  calculateStats,
  calcuteStats,
  getLockedPikuGAmount,
  getLockedPikugDate, getLockedPikuTime,
  getPikuBalance,
  getVePikuGAmount
} from "../../Service/Web3/Web3Service";

const Stats = () => {
  const translation = useTranslation();

  const { walletProvider } = useWeb3ModalProvider()
  const [tokenBalances, setTokenBalances] = useState({});
  const [stats, setStats] = useState({});
  useEffect(() => {
    const provider = new ethers.BrowserProvider(walletProvider)
    const fetchData = async () => {
      const singer = await provider.getSigner();

      const stats = await calculateStats(singer);
      setStats(stats);
      const vePiku = await getVePikuGAmount(singer);
      const pikuG = await getPikuBalance(singer, singer.getAddress());
      const lockedPikuG = await getLockedPikuGAmount(singer);
      let lockedDate = await getLockedPikuTime(singer);
      console.log("lockedDate", lockedDate);
      console.log("lockedDate", lockedDate.toString());
      if (lockedDate.toString() === "0") {
        lockedDate = "-";
      } else {
        lockedDate = new Date(parseInt(lockedDate) * 1000).toDateString()
      }
      setTokenBalances({
        vePikuBalance: parseFloat(vePiku).toFixed(2),
        pikuGBalance: parseFloat(pikuG).toFixed(2),
        lockedPikuGBalance: parseFloat(lockedPikuG).toFixed(2),
        lockedDate: lockedDate
      });

    }
    fetchData();
  }, [])

  const balancedlist = [
    {
      image: pikug,
      asset: "PikuG",
      amount: tokenBalances.pikuGBalance,
    },
    {
      image: vepikug,
      asset: "vePikuG",
      amount: tokenBalances.vePikuBalance,
    },
    {
      image: lockedpikug,
      asset: "Locked PikuG",
      amount: tokenBalances.lockedPikuGBalance,
    },
  ];

  return (
    <div className=" main_container pt-[90px] lg:pt-[120px]">
      <div className="max-w-[520px] mx-auto">
        <div className="p-[24px] lg:p-[32px] bg-[#222222] rounded-[24px]">
          <p className="text-[20px] lg:text-[24px] text-white aeonik_medium leading-[30px]">
            {translation.Stats}
          </p>
          <div className="mt-[24px] border-b-[1px] border-b-[#343434]">
            <div className="flex items-center justify-between">
              <p className="text-white lg:text-[18px] aeonik_normal leading-[23px]">

                Total PikuG Tokens Circulating
              </p>
              <p className="text-white text-[20px] aeonik_normal leading-[25px]">
                {parseFloat(stats.totalSupply).toFixed(2)}
              </p>
            </div>
            <div className="flex items-center justify-between my-[16px]">
              <p className="text-white lg:text-[18px] aeonik_normal leading-[23px]">

                Total PikuG Tokens Locked
              </p>
              <p className="text-white text-[20px] aeonik_normal leading-[25px]">
                {parseFloat(stats.lockedTotal).toFixed(2)}
              </p>
            </div>
            <div className="flex items-center justify-between mb-[16px]">
              <p className="text-white lg:text-[18px] aeonik_normal leading-[23px]">

                Percentage of Total PikuG Locked
              </p>
              <p className="text-white text-[20px] aeonik_normal leading-[25px]">
                %{parseFloat(stats.lockedPercentage).toFixed(2)}
              </p>
            </div>
          </div>
          <div className="flex items-center justify-between mt-[16px]">
            <p className="text-white lg:text-[18px] aeonik_normal leading-[23px]">

              Total vePikuG
            </p>
            <p className="text-white text-[20px] aeonik_normal leading-[25px]">
              {parseFloat(stats.totalVotingPower).toFixed(2)}
            </p>
          </div>
          <div className="flex items-center justify-between mt-[16px]">
            <p className="text-white lg:text-[18px] aeonik_normal leading-[23px]">

              Average Lock Time
            </p>
            <p className="text-white text-[20px] aeonik_normal leading-[25px]">
              {stats.updatedDate}
            </p>
          </div>
        </div>
        <div className="p-[32px] bg-[#222222] rounded-[24px] mt-[16px] lg:mt-[24px]">
          <p className="lg:text-[24px] text-white aeonik_medium leading-[30px]">
            {translation.Balances}
          </p>
          <div className="pt-[12px] border-b-[1px] border-b-[#343434] pb-[12px]">
            {balancedlist?.map((item, i) => (
              <div
                className="flex items-center justify-between mt-[12px]"
                key={i}
              >
                <div className="flex items-center">
                  <img
                    src={item.image}
                    alt="logo"
                    className="h-[32px] w-auto object-contain mr-[8px]"
                  />
                  <p className="lg:text-[18px] text-white aeonik_normal leading-[23px]">
                    {item.asset}
                  </p>
                </div>
                <p className="lg:text-[18px] text-white aeonik_normal leading-[23px]">
                  {item.amount}
                </p>
              </div>
            ))}
          </div>
          <div className="flex items-center justify-between mt-[16px]">
            <p className="text-[#9b9c9d] text-[14px] lg:text-[16px] aeonik_normal leading-[24px]">
              PikuG Locked Until
            </p>
            <p className="text-white text-[20px] aeonik_normal leading-[25px]">
              {tokenBalances.lockedDate}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Stats;
